module.exports = __webpack_public_path__ + "img/CM-EC-25-Lincoln-Modern.9e1a015f.jpg";